@use "../../design-tokens/typography/typography" as *;
@use "../../design-tokens/border-radius/border-radius" as *;

@layer design-system {
  .root {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .label {
    @include typography-v2-body-sm;
    color: var(--text-default);
    white-space: nowrap;
  }

  /* Width is overridable via the stable [data-control] attribute. */
  .control {
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: 138px;
    height: 32px;
  }

  .track {
    @include border-radius-r1;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 6px;
    background-color: var(--surface-default);
    transform: translateY(-50%);
    pointer-events: none;
  }

  .marks {
    position: absolute;
    inset: 0 10px;
    pointer-events: none;
  }

  .mark {
    position: absolute;
    top: 50%;
    width: 2px;
    height: 2px;
    background-color: var(--icon-disabled);
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  .input {
    position: relative;
    width: 100%;
    height: 32px;
    margin: 0;
    appearance: none;
    background: transparent;
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 6px;
      background: transparent;
    }

    &::-webkit-slider-thumb {
      @include border-radius-full;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      margin-top: -7px;
      appearance: none;
      border: 2px solid var(--surface-default);
      background-color: var(--surface-primary);
      box-shadow: var(--elevation-subtle);
      transition: box-shadow 0.15s ease;
    }

    &::-moz-range-track {
      width: 100%;
      height: 6px;
      background: transparent;
    }

    &::-moz-range-progress {
      background: transparent;
    }

    &::-moz-range-thumb {
      @include border-radius-full;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      border: 2px solid var(--surface-default);
      background-color: var(--surface-primary);
      box-shadow: var(--elevation-subtle);
      transition: box-shadow 0.15s ease;
    }

    &::-webkit-slider-thumb:hover,
    &::-webkit-slider-thumb:active {
      box-shadow: 0 0 0 6px var(--action-primary-soft-hover);
    }

    &::-moz-range-thumb:hover,
    &::-moz-range-thumb:active {
      box-shadow: 0 0 0 6px var(--action-primary-soft-hover);
    }

    &:focus-visible::-webkit-slider-thumb {
      outline: 2px solid var(--border-focus);
      outline-offset: 2px;
      box-shadow: 0 0 0 6px var(--action-primary-soft-hover);
    }

    &:focus-visible::-moz-range-thumb {
      outline: 2px solid var(--border-focus);
      outline-offset: 2px;
      box-shadow: 0 0 0 6px var(--action-primary-soft-hover);
    }
  }
}
